import { memo, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { AbsolutePopup, TPopupHorizontal, TPopupVertical } from 'core-components/library/popup'
import { CopiedText } from 'shared/components/copiedText'
import { List } from 'shared/components/list'

import { companyDetailsTranslations } from '../../../../translation'

import styles from './ItemArrayValue.module.scss'

export const ItemArrayValue = memo<{ value: string[] }>(({ value }) => {
  const [isFullListVisible, setIsFullListVisible] = useState(false)

  const handleOnChangeVisibility = useCallback((value: boolean) => {
    setIsFullListVisible(value)
    return value
  }, [])

  if (value.length === 0) {
    return <>-</>
  }

  if (value.length === 1) {
    return <CopiedText>{value[0]}</CopiedText>
  }

  return (
    <AbsolutePopup
      visibilityCallback={handleOnChangeVisibility}
      verticalStartPosition={TPopupVertical.Bottom}
      horizontalStartPosition={TPopupHorizontal.Left}
      horizontalOffset={-8}
      verticalOffset={2}
      popupContent={() => (
        <List className={styles.list}>
          {value.slice(1).map((item, index) => (
            <List.Item className={styles.listItem} key={index} onClick={() => {}}>
              <strong>{<CopiedText>{item}</CopiedText>}</strong>
            </List.Item>
          ))}
        </List>
      )}
    >
      <div className={styles.arrayItem}>
        <CopiedText>{value[0]}</CopiedText>
        {!isFullListVisible && (
          <a>
            <Translation
              text={companyDetailsTranslations.other.showMore}
              replaceParams={[{ key: '{count}', value: `${value.length - 1}` }]}
            />
          </a>
        )}
      </div>
    </AbsolutePopup>
  )
})
